import {
  PUSH_DIGIDIARY_VIEW,
  POP_DIGIDIARY_VIEW,
  RESET_DIGIDIARY_VIEW,
  DIGIDIARY_FARM_SETUP,
  FARM_INFO_RESET,
  DIGIDIARY_EQUIPMENT_SETUP,
  DIGIDIARY_EQUIPMENT_DETAILS_RESET,
  SET_ACTIVE_FOOTER,
  SHOW_HIDE_FOOTER,
  SHOW_HIDE_HEADER,
  SET_CROP_VIEW_MODE,
  SET_EQUIPMENT_VIEW_MODE,
  DIGIDIARY_SET_EXPENSE_TOTAL,
  SET_SELECTED_CROP_ID,
  SET_SELECTED_EQUIPMENT_ID,
  SET_ALL_EQUIPMENT,
  DD_LOAD_EXISTING_EQUIPMENT,
  DIGIDIARY_GET_EXPENSE_INFO,
} from './actionTypes';

export const pushDigiDiaryViewAction = (data) => {
  return {
    type: PUSH_DIGIDIARY_VIEW,
    newView: data,
  };
};
export const popDigiDiaryViewAction = () => {
  return {
    type: POP_DIGIDIARY_VIEW,
  };
};
export const resetDigiDiaryViewAction = () => {
  return {
    type: RESET_DIGIDIARY_VIEW,
  };
};

export const digiDiaryFarmAction = (data) => {
  return {
    type: DIGIDIARY_FARM_SETUP,
    data: data,
  };
};

export const digiDiaryFarmInfoReset = () => {
  return {
    type: FARM_INFO_RESET,
  };
};

export const digiDiaryEquipmentAction = (data) => {
  return {
    type: DIGIDIARY_EQUIPMENT_SETUP,
    data: data,
  };
};

export const digiDiaryEquipmentDetailsReset = () => {
  return {
    type: DIGIDIARY_EQUIPMENT_DETAILS_RESET,
  };
};

export const setActiveFooter = (data) => {
  return {
    type: SET_ACTIVE_FOOTER,
    data,
  };
};

export const setShowHideFooter = (data) => {
  return {
    type: SHOW_HIDE_FOOTER,
    data,
  };
};

export const setShowHideHeader = (data) => {
  return {
    type: SHOW_HIDE_HEADER,
    data,
  };
};

export const setCropViewModeAction = (data) => {
  return {
    type: SET_CROP_VIEW_MODE,
    data,
  };
};

export const setSelectedCropId = (data) => {
  return {
    type: SET_SELECTED_CROP_ID,
    data,
  };
};

export const setSelectedEquipmentId = (data) => {
  return {
    type: SET_SELECTED_EQUIPMENT_ID,
    data,
  };
};

export const setAllEquipment = (data) => {
  return {
    type: SET_ALL_EQUIPMENT,
    data,
  };
};

export const setEquipmentViewModeAction = (data) => {
  return {
    type: SET_EQUIPMENT_VIEW_MODE,
    data,
  };
};

export const setExpenseTotalAction = (data) => {
  return {
    type: DIGIDIARY_SET_EXPENSE_TOTAL,
    data,
  };
};

export const setExpenseTypes = (data) => {
  return {
    type: DIGIDIARY_GET_EXPENSE_INFO,
    data,
  };
};

export const loadExistingEquipment = () => {
  return {
    type: DD_LOAD_EXISTING_EQUIPMENT,
  };
};
